<ng-template #checkoutPopupContent let-closeModal="close">
    <mlp-ng-modal>
        <div header class="sg-heading__h5">Checkout</div>
        <div body class="mx-auto">
            <div class="row">
                <div class="col">
                    <pf-booking-details
                        [slot]="checkoutData.slot"
                        [pitch]="checkoutData.pitchData"
                        [venue]="checkoutData.venueData"
                        [hideMobileThumbnail]="true"
                        [modal]="true"
                    ></pf-booking-details>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col text-center">
                    <mlp-ng-button
                        (click)="checkout()"
                        label="Go To"
                        labelSecondary="Checkout"
                        fullWidth="1"
                    ></mlp-ng-button>
                </div>
            </div>
        </div>
    </mlp-ng-modal>
</ng-template>
